/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useParams } from 'react-router-dom';
import NavBar from '../sharedComponents/NavBar';
import { APPS_TABS } from '../sharedComponents/navTabs';
import AppHeader from '../sharedComponents/AppHeader';
import '../../styles/AppScreen.css';
import AgentCard from '../sharedComponents/AgentCard';
import AgentImg from '../../assets/logos/IntakeReviewAgent.svg';
import ApplicationAssistant from '../../assets/logos/ApplicationStatusAgent.svg';
import BenefitAgentIcon from '../../assets/logos/BenefitAgent.svg';
import DocAgent from '../../assets/logos/DocumentQualityAgent.svg';
import EligibilityAgent from '../../assets/logos/EligibilityReviewAgent.svg';
import BackNavigation from '../sharedComponents/BackNavigation/BackNavigation';

const AppScreen = ({ logedInUserMail }) => {
  const location = useLocation();
  const agents = [
    {
      image: AgentImg,
      title: "Intake Review Agent",
      description:
      "Analyzes incoming applications to detect potential duplicates, supporting reviewers in maintaining data accuracy and preventing processing errors.",
      to: "/intake-agent",
    },
    {
      image: BenefitAgentIcon,
      title: "Benefits Agent",
      description:
      "Evaluates applicant records to identify potential duplication of benefits, helping reviewers ensure compliance, accuracy, and proper fund allocation.",
      to: "/benefit-agent",
    },
    {
      image: EligibilityAgent,
      title: "Eligibility Review Agent",
      description:
      "Assists case managers by reviewing eligibility, flagging issues, and enabling faster, accurate, and compliant reviews.",
      to: "/eligibility-review-agent",
    },
    {
      image: ApplicationAssistant,
      title: "Application Status Agent",
      description:
      "Assists case managers by providing real-time status and summarized notes, reducing manual checks and dependency.",
      to: "/application-status-agent",
    },

    {
      image: DocAgent,
      title: "Document Quality Agent",
      description:
      "Assists case managers by analyzing application documents to ensure quality, enabling timely and accurate reviews.",
      to: "/doc-agent",
    },
  ];

  return (
    <div className="chat-container">
      <NavBar logedInUserMail={logedInUserMail} tabs={APPS_TABS} activeTabKey="agents" />
      <div className="agentAppContainer">
        <div className="appHeader">
          <BackNavigation to="/" label='Back to Homepage' />
          <AppHeader title="Agentic Workflows & Apps" />
          <div className="agentCardsRow">
            {agents.map((agent, idx) => (
              <AgentCard
                image={agent.image}
                title={agent.title}
                description={agent.description}
                to={agent.to}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

AppScreen.propTypes = {
  logedInUserMail: PropTypes.string.isRequired,
};

export default AppScreen;
